import { QuestionsTextDE } from './QuestionTextsDe'
import { QuestionsTextFR } from './QuestionTextsFr'

const Questions: { [key: string]: Question } = {
  relationship_status: {
    id: 'relationship_status',
    inputtype: 'radio',
    sort: 3,
  },
  relationship_duration: {
    id: 'relationship_duration',
    inputtype: 'slider',
    min: 0,
    max: 50,
    step: 1,
    initial: 0,
    unit: 'Jahre',
    sort: 4,
  },
  relationship_duration_single: {
    id: 'relationship_duration',
    inputtype: 'slider',
    min: 0,
    max: 50,
    step: 1,
    initial: 0,
    unit: 'Jahre',
    sort: 4,
  },
  gender: {
    id: 'gender',
    inputtype: 'radio',
    sort: 0,
  },
  sexual_orientation: {
    id: 'sexual_orientation',
    inputtype: 'radio',
    sort: 5,
  },
  age: {
    id: 'age',
    inputtype: 'radio',
    sort: 1,
  },
  education: {
    id: 'education',
    inputtype: 'radio',
    sort: 2,
  },
  satisfaction: {
    id: 'satisfaction',
    inputtype: 'slider',
    min: 0,
    max: 10,
    step: 1,
    initial: 5,
    sort: 6,
  },
  sex_frequency: {
    id: 'sex_frequency',
    inputtype: 'radio',
    sort: 7,
  },
  sex_frequency_desired: {
    id: 'sex_frequency_desired',
    inputtype: 'radio',
    sort: 8,
  },
  orgasm_frequency_sex: {
    id: 'orgasm_frequency_sex',
    inputtype: 'slider',
    min: 0,
    max: 100,
    step: 5,
    initial: 50,
    unit: '%',
    sort: 9,
  },
  orgasm_frequency_desired: {
    id: 'orgasm_frequency_desired',
    inputtype: 'radio',
    sort: 10,
  },
  pleasure_frequency_sex: {
    id: 'pleasure_frequency_sex',
    inputtype: 'slider',
    min: 0,
    max: 100,
    step: 5,
    initial: 50,
    unit: '%',
    sort: 11,
  },
  masturbation_frequency: {
    id: 'masturbation_frequency',
    inputtype: 'radio',
    sort: 12,
  },
  orgasm_frequency_masturbation: {
    id: 'orgasm_frequency_masturbation',
    inputtype: 'slider',
    min: 0,
    max: 100,
    step: 5,
    initial: 50,
    unit: '%',
    sort: 13,
  },
  pleasure_frequency_masturbation: {
    id: 'pleasure_frequency_masturbation',
    inputtype: 'slider',
    min: 0,
    max: 100,
    step: 5,
    initial: 50,

    unit: '%',
    sort: 14,
  },
  group_agree: {
    id: 'group_agree',
    inputtype: 'slider',
    sort: 15,
  },
  group_agree_like: {
    id: 'group_agree_like',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 21,
  },
  group_agree_demand: {
    id: 'group_agree_demand',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 22,
  },
  group_agree_think: {
    id: 'group_agree_think',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 23,
  },
  genital_look: {
    id: 'genital_look',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 16,
  },
  genital_function: {
    id: 'genital_function',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 17,
  },
  realize_sexual_demands: {
    id: 'realize_sexual_demands',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial:3,
    sort: 18,
  },
  communicate_needed_mood: {
    id: 'communicate_needed_mood',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 19,
  },
  right_to_orgasm: {
    id: 'right_to_orgasm',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 20,
  },
}

export function getQuestionData(lang: 'de' | 'fr') {
  var text = lang === 'de' ? QuestionsTextDE : QuestionsTextFR
  Object.entries(Questions).map(([key, value]) => {
    value.question = text[key].question
    if (text[key].options) {
      value.options = text[key].options
    }
    if (text[key].labels) {
      value.labels = text[key].labels
    }
    return value
  })
  return Questions
}
